import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostDataSecurityStatusRequest = {
	enable: boolean
};

export const postDataSecurityStatus = createPostEndpoint<PostDataSecurityStatusRequest>(
	'/api/v3/data-security/management/enabled'
);
